/*
 * Trustpilot TrustBox initialiser.
 *
 * Each widget hydrates exactly once via IntersectionObserver (above-the-fold
 * widgets hydrate immediately because they already intersect). Uses
 * loadFromElement(el, false) so Trustpilot does not tear down and reload iframes.
 */
(function () {
  var SELECTOR =
    '.sfw-subheader-trust .trustpilot-widget, .footer-sfw__trustpilot .trustpilot-widget';

  var done = typeof WeakSet === 'function' ? new WeakSet() : null;
  var observer = null;

  function tpReady() {
    return !!(window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function');
  }

  function hydrate(el) {
    if (!el || (done && done.has(el))) return true;
    if (!tpReady()) return false;
    if (el.getBoundingClientRect().width < 1) return false;

    if (done) done.add(el);
    try {
      window.Trustpilot.loadFromElement(el, false);
    } catch (e) {
      /* Leave the fallback link visible on network/service errors. */
    }
    return true;
  }

  function observeWidget(el) {
    if (!el || (done && done.has(el))) return;
    if (!observer) return;
    observer.observe(el);
  }

  function initAll() {
    var widgets = document.querySelectorAll(SELECTOR);
    if (!widgets.length) return;

    if ('IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              if (hydrate(entry.target)) {
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.01 }
        );
      }

      Array.prototype.forEach.call(widgets, observeWidget);
      return;
    }

    Array.prototype.forEach.call(widgets, hydrate);
  }

  function whenReady(cb) {
    if (tpReady()) {
      cb();
      return;
    }

    window.addEventListener(
      'load',
      function () {
        if (tpReady()) {
          cb();
          return;
        }
        window.setTimeout(function () {
          if (tpReady()) cb();
        }, 300);
      },
      { once: true }
    );
  }

  whenReady(initAll);

  document.addEventListener('shopify:section:load', function () {
    whenReady(initAll);
  });

  // Carousel: hydrate Trustpilot when its slide becomes active (IO can miss scroll-snap moves).
  document.addEventListener('sfw:subheader-slide-visible', function (event) {
    if (!event.detail || !event.detail.slide) return;
    var widget = event.detail.slide.querySelector('.trustpilot-widget');
    if (widget) hydrate(widget);
  });
})();
